import useSWR from "swr";
import { endpointsAssets } from "lib/actions/endpoints/endpointsAssets";
import { fetcher } from "lib/actions/fetcher";
import { getAssetFromResponse } from "lib/actions/assets/getAssetFromResponse";
import { maxBy } from "lib/actions/util";
import { useMemo } from "react";

export function useAsset(assetId: number) {
  const {
    data: asset,
    isLoading,
    error,
    mutate,
  } = useSWR(assetId && endpointsAssets.asset(assetId), (url) =>
    fetcher(url).then(getAssetFromResponse),
  );

  const versions = useMemo(
    () =>
      asset?.versions.map((version) => ({
        ...version,
        asset,
      })),
    [asset],
  );
  const latestVersion = maxBy(versions, (version) => version.createdOn);

  return {
    asset,
    versions,
    latestVersion,
    hasError: !assetId || !!error,
    isLoading: !asset && isLoading,
    mutate: async () => {
      await mutate();
    },
  };
}
